/**
 * Local id generation for user-created rows.
 *
 * `crypto.randomUUID()` is unavailable on insecure origins in some browsers,
 * and `Date.now()` alone collides when two rows are added in the same
 * millisecond (add-form spam is exactly that). Timestamp + monotonic counter
 * is collision-free within a session and sorts stably across sessions.
 *
 * This is the one non-pure function in src/lib/dailies — it is deliberately
 * kept out of the migrate and status functions so those stay fully testable.
 */
let counter = 0;

export function createId(prefix: 'health' | 'todo' | 'media'): string {
  counter += 1;
  return `${prefix}-${Date.now().toString(36)}-${counter.toString(36)}`;
}
